// Regroupement des 60+ types de notifications existants en 5 catégories — aucun nouveau type
// créé, ce sont les mêmes notifications qu'avant, juste triées différemment. Sans ce regroupement
// en familles, un aperçu ou un écran qui afficherait une ligne par type finirait à plusieurs
// dizaines de lignes (participations, prestations, paiements, rituels, communautés, tops...) —
// voir l'inventaire complet fait le 2026-09-06. Extrait pour être réutilisé à la fois par
// pages/Notifications.tsx (écran complet, onglets) et le panneau d'aperçu de la cloche
// (components/Layout.tsx) sans dupliquer ces listes à deux endroits.

// "Demandes" : notifications qui attendent une VRAIE décision de la part du destinataire
// (accepter/refuser) — amis, participations, adhésions rituels/communautés, réservations,
// devis à négocier, co-organisation. Une fois la décision prise par l'AUTRE partie, la
// notification de résultat part dans "Prestations" ou "Activités", jamais ici.
export const DEMANDE_TYPES = [
  "friend_request", "participation", "ritual_join_request", "community_join_request",
  "booking_request", "venue_booking_request", "power_offer", "offer_negotiation",
  "pro_event_collab_invite",
];

// "Connexions & Likes" : toute validation sociale/romantique — likes, matchs, tops (story_like),
// dates, mentions, nouveaux arrivants à proximité, filleuls.
export const CONNECTION_TYPES = [
  "like", "match", "date_invitation", "date_accepted", "photo_like", "story_like", "new_real",
  "friend_accepted", "mention", "user_joined_nearby", "referral_joined",
];
// Ancien nom, conservé en alias — CONNECTION_TYPES est le nom à jour depuis que ce bucket couvre
// bien plus que les simples likes (matchs, dates, tops, mentions...).
export const LIKE_TYPES = CONNECTION_TYPES;

// "Prestations" : réponses à une demande de service/adhésion déjà envoyée — devis, réservations,
// catalogue Powers/Passions, co-orga, rituels/communautés, opportunités de prestation à proximité.
export const PRESTATION_TYPES = [
  "offer_accepted", "offer_declined", "booking_confirmed", "booking_cancelled", "booking_refunded",
  "venue_booking_confirmed", "venue_booking_cancelled", "catalog_proposal_approved",
  "catalog_proposal_rejected", "pro_event_collab_accepted", "ritual_request_approved",
  "community_request_approved", "power_request_nearby",
];

// "Paiements" : tout ce qui touche à l'argent — virements, litiges, ventes, points fidélité.
export const PAIEMENT_TYPES = [
  "payment_released", "payment_disputed", "payment_refunded", "item_sold",
  "venue_points_credited", "venue_item_points_purchase",
];

const BUCKETED_TYPES = new Set([...DEMANDE_TYPES, ...CONNECTION_TYPES, ...PRESTATION_TYPES, ...PAIEMENT_TYPES]);

export type NotificationBuckets = { activites: any[]; demandes: any[]; connexions: any[]; prestations: any[]; paiements: any[] };

// "Activités" reste le fourre-tout par défaut (messages, commentaires, anniversaires, compte,
// FAST...) — tout type qui n'apparaît dans aucune des 4 listes ci-dessus y retombe automatiquement,
// donc un futur nouveau type de notification jamais catégorisé n'est jamais perdu/invisible.
export function bucketNotifications(notifs: any[]): NotificationBuckets {
  const demandes = notifs.filter(n => DEMANDE_TYPES.includes(n.type));
  const connexions = notifs.filter(n => CONNECTION_TYPES.includes(n.type));
  const prestations = notifs.filter(n => PRESTATION_TYPES.includes(n.type));
  const paiements = notifs.filter(n => PAIEMENT_TYPES.includes(n.type));
  const activites = notifs.filter(n => !BUCKETED_TYPES.has(n.type));
  return { activites, demandes, connexions, prestations, paiements };
}
